// extracted by mini-css-extract-plugin
module.exports = {"root":"ProdottiSection_root__1EBPT","slider":"ProdottiSection_slider___q4dW","rotation":"ProdottiSection_rotation__U4aZm"};